<template>
    <div class="form-item form-input"
         :class="{ 'form-item--error': errors.has(name) && showErrors }">
        <input :type="type ? type : 'text'"
               :placeholder="label"
               :name="name"
               :id="'register_form_' + name"
               :ref="name"
               v-validate
               v-model="value"
               :data-vv-rules="rules"
               :data-vv-as="label"
               :disabled="progress || disabled">
        <p class="field-error--description field-error--description--white" v-show="errors.has(name) && showErrors">{{ errors.first(name) }}</p>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['label', 'name', 'progress', 'rules', 'showErrors', 'type', 'updateValue', 'disabled', 'default'],
        data () {
            return {
                value: ''
            }
        },
        watch: {
            value () {
                this.updateValue(this.name, this.value);
            }
        },
        beforeMount () {
            if (this.default) {
                this.value = this.default;
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        text-transform: capitalize;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        text-transform: capitalize;
    }
    :-ms-input-placeholder { /* IE 10+ */
        text-transform: capitalize;
    }
    :-moz-placeholder { /* Firefox 18- */
        text-transform: capitalize;
    }
</style>


// WEBPACK FOOTER //
// src/components/register/partials/fields/Textfield.vue